import { utils } from '@febos-io/common';

import * as types from './types';

export const initialState = {
  loading: {
    patients: false,
    exams: false,
    clinics: false,
    users: false,
    appointments: false,
    reservingAppointments: false,
    schedulers: false,
    schedulerStates: false,
  },
  lists: {},
  lastSelected: {
    clinic: null,
  },
  users: {},
  pendingFiles: {},
  selectedPatient: undefined,
};

export const slice = utils.createSlice('healthCommon', initialState, {
  [types.SET_CONFIGURATIONS](state, { payload: { companyId, configurations, }, }) {
    const oldState = {
      ...initialState,
      ...state,
    };
    return {
      ...oldState,
      lists: {
        ...oldState.lists,
        [companyId]: {
          ...oldState.lists[companyId],
          configurations: {
            ...oldState.lists[companyId]?.configurations,
            ...configurations,
          },
        },
      },
    };
  },
  [types.SET_LIST_PATIENTS](state, { payload: { companyId, patients, }, }) {
    const oldState = {
      ...initialState,
      ...state,
    };
    return {
      ...oldState,
      lists: {
        ...oldState.lists,
        [companyId]: {
          ...oldState.lists[companyId],
          patients: {
            ...oldState.lists[companyId]?.patients,
            ...patients,
          },
        },
      },
    };
  },
  [types.SET_LIST_USERS](state, { payload: { companyId, filter = '0A', users, }, }) {
    const oldState = {
      ...initialState,
      ...state,
    };
    return {
      ...oldState,
      users: {
        [companyId]: {
          ...oldState.users[companyId],
          [filter]: {
            users: {
              ...users,
            },
          },
        },
      },
    };
  },
  [types.SET_LIST_EXAMS](state, { payload: { companyId, exams, }, }) {
    const oldState = {
      ...initialState,
      ...state,
    };
    return {
      ...oldState,
      lists: {
        ...oldState.lists,
        [companyId]: {
          ...oldState.lists[companyId],
          exams: {
            ...oldState.lists[companyId]?.exams,
            ...exams,
          },
        },
      },
    };
  },
  [types.SET_LIST_CLINICS](state, { payload: { companyId, clinics, }, }) {
    const oldState = {
      ...initialState,
      ...state,
    };
    return {
      ...oldState,
      lists: {
        ...oldState.lists,
        [companyId]: {
          ...oldState.lists[companyId],
          clinics: {
            ...oldState.lists[companyId]?.clinics,
            ...clinics,
          },
        },
      },
    };
  },

  [types.SET_LOADING_PATIENTS](state, { payload, }) {
    const oldState = {
      ...initialState,
      ...state,
    };
    return {
      ...oldState,
      loading: {
        ...oldState.loading,
        patients: payload,
      },
    };
  },

  [types.SET_LOADING_EXAMS](state, { payload, }) {
    const oldState = {
      ...initialState,
      ...state,
    };
    return {
      ...oldState,
      loading: {
        ...oldState.loading,
        exams: payload,
      },
    };
  },

  [types.SET_LAST_CLINICS](state, { payload: { companyId, clinicId, }, }) {
    const oldState = {
      ...initialState,
      ...state,
    };
    return {
      ...oldState,
      lastSelected: {
        [companyId]: {
          ...oldState[companyId],
          clinic: clinicId,
        },
      },
    };
  },

  [types.SET_LOADING_CLINICS](state, { payload, }) {
    const oldState = {
      ...initialState,
      ...state,
    };
    return {
      ...oldState,
      loading: {
        ...oldState.loading,
        clinics: payload,
      },
    };
  },

  [types.SET_LOADING_COMPANY_USERS](state, { payload, }) {
    const oldState = {
      ...initialState,
      ...state,
    };
    return {
      ...oldState,
      loading: {
        ...oldState.loading,
        users: payload,
      },
    };
  },

  [types.SET_LOADING_APPOINTMENTS](state, { payload, }) {
    const oldState = {
      ...initialState,
      ...state,
    };
    return {
      ...oldState,
      loading: {
        ...oldState.loading,
        appointments: payload,
      },
    };
  },
  [types.SET_LOADING_RESERVE_APPOINTMENTS](state, { payload, }) {
    const oldState = {
      ...initialState,
      ...state,
    };
    return {
      ...oldState,
      loading: {
        ...oldState.loading,
        reservingAppointments: payload,
      },
    };
  },

  [types.SET_LOADING_SCHEDULERS](state, { payload, }) {
    const oldState = {
      ...initialState,
      ...state,
    };
    return {
      ...oldState,
      loading: {
        ...oldState.loading,
        schedulers: payload,
      },
    };
  },
  [types.SET_LIST_SCHEDULERS](state, { payload: { companyId, locationId, shedulers, }, }) {
    const oldState = {
      ...initialState,
      ...state,
    };
    const shedulerResourceMap = shedulers?.reduce((acc, curr) => {
      acc[curr.resourceId] = curr;
      return acc;
    }, {});
    return {
      ...oldState,
      lists: {
        ...oldState.lists,
        [companyId]: {
          ...oldState.lists[companyId],
          schedulers: {
            ...oldState.lists[companyId]?.schedulers,
            [locationId]: {
              ...oldState.lists[companyId]?.schedulers?.[locationId],
              ...shedulerResourceMap,
            },
          },
        },
      },
    };
  },
  [types.SET_LIST_APPOINTMENTS](state, { payload: { companyId, locationId, appointments, }, }) {
    const oldState = {
      ...initialState,
      ...state,
    };
    const appointMentsByFecha = appointments?.reduce((acc, curr) => {
      const fecha = curr.fecha;
      if (!acc[fecha]) {
        acc[fecha] = [];
      }
      acc[fecha].push(curr);
      return acc;
    }, {});

    const newState = {
      ...oldState,
      lists: {
        ...oldState.lists,
        [companyId]: {
          ...oldState.lists[companyId],
          appointments: {
            ...oldState.lists[companyId]?.appointments,
            company: {
              ...oldState.lists[companyId]?.appointments?.company,
              ...appointMentsByFecha,
            },
            [locationId]: {
              ...oldState.lists[companyId]?.appointments?.[locationId],
              ...appointMentsByFecha,
            },
          },
        },
      },
    };
    return newState;
  },
  [types.SET_APPOINTMENT](state, { payload: { appointment, }, }) {
    const { companyId, locationId, } = appointment;
    const oldState = {
      ...initialState,
      ...state,
    };
    // eslint-disable-next-line max-len
    const oldAppointments = oldState.lists[companyId]?.appointments?.[locationId]?.[appointment.fecha] || [];
    // add or replace appointment in oldAppointments
    const newList = oldAppointments.filter((app) => app.citaId !== appointment.citaId);
    const appointments = [...newList, appointment];
    const newState = {
      ...oldState,
      lists: {
        ...oldState.lists,
        [companyId]: {
          ...oldState.lists[companyId],
          appointments: {
            ...oldState.lists[companyId]?.appointments,
            company: {
              ...oldState.lists[companyId]?.appointments?.company,
            },
            [locationId]: {
              ...oldState.lists[companyId]?.appointments?.[locationId],
              // eslint-disable-next-line max-len
              [appointment.fecha]: appointments,
            },
          },
        },
      },
    };
    return newState;
  },

  [types.SET_LOADING_SCHEDULER_STATES](state, { payload, }) {
    const oldState = {
      ...initialState,
      ...state,
    };
    return {
      ...oldState,
      loading: {
        ...oldState.loading,
        schedulerStates: payload,
      },
    };
  },

  [types.SET_LIST_SCHEDULER_STATES](state, { payload: { companyId, schedulerStates, }, }) {
    const oldState = {
      ...initialState,
      ...state,
    };
    const schedulerStatesMap = schedulerStates?.reduce((acc, curr) => {
      acc[curr.statusId] = curr;
      return acc;
    }, {});
    return {
      ...oldState,
      lists: {
        ...oldState.lists,
        [companyId]: {
          ...oldState.lists[companyId],
          schedulerStates: {
            ...oldState.lists[companyId]?.schedulerStates,
            ...schedulerStatesMap,
          },
        },
      },
    };
  },
  [types.SET_SCHEDULER_STATE](state, { payload: { companyId, schedulerState, }, }) {
    const oldState = {
      ...initialState,
      ...state,
    };
    return {
      ...oldState,
      lists: {
        ...oldState.lists,
        [companyId]: {
          ...oldState.lists[companyId],
          schedulerStates: {
            ...oldState.lists[companyId]?.schedulerStates,
            [schedulerState.statusId]: schedulerState,
          },
        },
      },
    };
  },
  [types.REMOVE_SCHEDULER_STATE](state, { payload: { companyId, statusId, }, }) {
    const oldState = {
      ...initialState,
      ...state,
    };
    const {
      [statusId]: removedState,
      ...remainingStates
    } = oldState.lists[companyId]?.schedulerStates || {};
    return {
      ...oldState,
      lists: {
        ...oldState.lists,
        [companyId]: {
          ...oldState.lists[companyId],
          schedulerStates: {
            ...remainingStates,
            [statusId]: {
              ...removedState,
              isDeleted: true,
            },
          },
        },
      },
    };
  },

  [types.SET_CLEAN_APPOINTMENTS_RESULT](state, {
    payload: {
      companyId, locationId, cleanedCount, remainingCount,
    },
  }) {
    const oldState = {
      ...initialState,
      ...state,
    };
    return {
      ...oldState,
      lists: {
        ...oldState.lists,
        [companyId]: {
          ...oldState.lists[companyId],
          cleanupResults: {
            ...oldState.lists[companyId]?.cleanupResults,
            [locationId]: {
              cleanedCount,
              remainingCount,
              lastCleanup: new Date().toISOString(),
            },
          },
        },
      },
    };
  },

  SET_CLEANED_APPOINTMENTS(state, { payload: { companyId, locationId, appointments, }, }) {
    const oldState = {
      ...initialState,
      ...state,
    };
    return {
      ...oldState,
      lists: {
        ...oldState.lists,
        [companyId]: {
          ...oldState.lists[companyId],
          appointments: {
            ...oldState.lists[companyId]?.appointments,
            [locationId]: appointments,
          },
        },
      },
    };
  },
  [types.SET_PENDING_FILES](state, { payload: { clinicId, files, }, }) {
    const oldState = {
      ...initialState,
      ...state,
    };
    return {
      ...oldState,
      pendingFiles: {
        ...oldState?.pendingFiles,
        [clinicId]: {
          ...oldState?.pendingFiles?.[clinicId],
          ...files,
        },
      },
    };
  },
  [types.CLEAR_PENDING_FILES](state, { payload: { clinicId, }, }) {
    const oldState = {
      ...initialState,
      ...state,
    };
    return {
      ...oldState,
      pendingFiles: {
        ...oldState?.pendingFiles,
        [clinicId]: {},
      },
    };
  },
  [types.SET_PENDING_FILE](state, { payload: { clinicId, fileId, file, }, }) {
    const oldState = {
      ...initialState,
      ...state,
    };
    return {
      ...oldState,
      pendingFiles: {
        ...oldState?.pendingFiles,
        [clinicId]: {
          ...oldState?.pendingFiles?.[clinicId],
          [fileId]: file,
        },
      },
    };
  },
  [types.SET_SELECTED_PATIENT](state, { payload: patient, }) {
    return {
      ...state,
      selectedPatient: patient,
    };
  },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
export default slice.reducer;
